import React, { useState, useEffect, useCallback, forwardRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "cms/auth/auth/hooks/useAuth";
import { solid } from "icons";
import { SidePanel } from "./side-panel";
import { WhenSignedIn } from "mydnv/components/sign-in/sign_in_out_util";
import { useMyDNVContext } from "mydnv/context/mydnv-context";

export const Bookmark = (({buttonRef, ...props}) => {
    const [isPaneOpen, setIsPaneOpen] = useState(false);
    const [sortedBookmarks, setSortedBookmarks] = useState([]);
    const paneControl = () => {
        setIsPaneOpen(!isPaneOpen);
    };

    const { token } = useAuth();
    let { bookmarks } = useMyDNVContext();

    const sortBookmarks = (bookmarksToSort) => {
        return [...bookmarksToSort].sort((a, b) => a.order - b.order);
    };

    const handleBookmarkDetailEvaluations = useCallback(() => {
        setSortedBookmarks(sortBookmarks(JSON.parse(bookmarks)));
    }, [bookmarks]);

    useEffect(() => {
        if (bookmarks && bookmarks.length > 0) {
            handleBookmarkDetailEvaluations();
        }
    }, [bookmarks, handleBookmarkDetailEvaluations]);

    return (
        <>
            <WhenSignedIn>
                <button className="btn btn-bookmark topbar-button" onClick={paneControl} {...props} ref={buttonRef}>
                    <FontAwesomeIcon icon={solid.faBookmark} size={"lg"} />
                </button>
            </WhenSignedIn>
            <SidePanel
                title={"Bookmarks"}
                bookmarks={sortedBookmarks}
                isPaneOpen={isPaneOpen}
                closeHandler={paneControl}
                isMobile={false}
            ></SidePanel>
        </>
    );
});
